// Copyright 2025, University of Maryland, All Rights Reserved
import { Navigate } from 'react-router-dom';
import { Shield, Users, UserCog, ArrowRightLeft } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@umd-dit-ai-workspace/shared-ui';
import { useAuth } from '@umd-dit-ai-workspace/workspaces-component';
import { DefaultsConfigurationView } from '../components/DefaultsConfigurationView';
import { WorkspaceConfigurationView } from '../components/WorkspaceConfigurationView';
import { MemberDefaultsConfigurationView } from '../components/MemberDefaultsConfigurationView';
import { WorkspaceTransferView } from '../components/WorkspaceTransferView';

export default function ConfigPage() {
  const { isAdmin, currentWorkspace } = useAuth()
  if (!isAdmin && currentWorkspace?.role !== 'admin') return <Navigate to="/" replace />

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow p-6">
        <div className="mb-6">
          <h2 className="text-2xl font-bold mb-2">Configuration Management</h2>
          <p className="text-gray-600">
            Manage system defaults and workspace configurations for templates and prompts.
          </p>
        </div>

        <Tabs defaultValue="defaults">
          <TabsList className="mb-6">
            <TabsTrigger value="defaults" className="flex items-center space-x-2">
              <Shield className="w-4 h-4" />
              <span>Defaults</span>
            </TabsTrigger>
            <TabsTrigger value="workspace" className="flex items-center space-x-2">
              <Users className="w-4 h-4" />
              <span>Workspace</span>
            </TabsTrigger>
            <TabsTrigger value="member-defaults" className="flex items-center space-x-2">
              <UserCog className="w-4 h-4" />
              <span>Member Defaults</span>
            </TabsTrigger>
            {isAdmin && (
              <TabsTrigger value="workspace-transfer" className="flex items-center space-x-2">
                <ArrowRightLeft className="w-4 h-4" />
                <span>Workspace Transfer</span>
              </TabsTrigger>
            )}
          </TabsList>

          <TabsContent value="defaults">
            <DefaultsConfigurationView />
          </TabsContent>

          <TabsContent value="workspace">
            <WorkspaceConfigurationView />
          </TabsContent>

          <TabsContent value="member-defaults">
            <MemberDefaultsConfigurationView />
          </TabsContent>

          {isAdmin && (
            <TabsContent value="workspace-transfer">
              <WorkspaceTransferView />
            </TabsContent>
          )}
        </Tabs>
      </div>
    </div>
  );
}